"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("../../utils/styles/ontario-icon.scss");
const CalendarIcon = ({ useMinWidth = false }) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ className: "ontario-icon", "aria-hidden": "true", focusable: "false", viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid meet", style: useMinWidth ? { minWidth: '66px', marginRight: 0 } : { marginRight: 8 } }, { children: (0, jsx_runtime_1.jsx)("use", { fill: "#03713D", xlinkHref: require("../../assets/ontario-icons-secondary.svg").default +
                "#ontario-icon-calendar" }) })));
};
exports.CalendarIcon = CalendarIcon;
